import { login, setLoading, setError, logout, setUserData } from "../redux/authSlice";
import lsApi from "../api/lsApi";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { LoginResponse, IUser } from '../models/auth';
// OneSignal removido - lógica desarrollada en otro lugar
import { esCUI } from "../utils/numbers";

export default function useLogin() {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const userData = useAppSelector((state) => state.auth.userData)


    const loginHandler = async (userName: string, password: string) => {

        dispatch(setLoading(true))

        try {
            const { data } = await lsApi.post<LoginResponse>("/api/Core/login", { userName, password })
            if (data.success) {
                localStorage.setItem("token", data.access_token)
                await validateToken()
            }
            else {
                dispatch(setError("Invalid Credentials"))
                alert("Credenciales Invalidas")
            }
        }
        catch (error) {
            dispatch(setError("Login Failed"))
            alert("Credenciales Invalidas")
        }

        dispatch(setLoading(false))
    }

    const logoutHandler = () => {

        dispatch(logout())
        dispatch(setUserData({} as IUser))
        localStorage.removeItem("token")
        navigate("/login")

    }

    const validateToken = async () => {

        const token = localStorage.getItem("token")

        if (!token) {
            return
        }

        let userData: IUser | null = null;

        try {
            const { data, status } = await lsApi.get<IUser>("/api/ControlAcceso/DatosUsuario")
            if (status === 200) {
                userData = data; // Guardar datos del usuario para usar después
                dispatch(setUserData(data))
                dispatch(login({
                    access_token: token,
                    message: "Login Success",
                    success: true
                }))
                
            }
            else {
                dispatch(logout())
                localStorage.removeItem("token")
                navigate("/login")
            }
        }
        catch (error) {
            dispatch(setError("Invalid Token"))
        }
    }

    const updateUserData = async (nombre: string, email: string, nit: string, longitud: string, latitud: string, telefono: string, nombreF: string, direccionF: string) => {

        const { empresa, agencia, casa, usuario } = userData!
        try {
            const { data } = await lsApi.put("/api/ControlAcceso/ActualizarDatosUsuario", {
                empresa,
                agencia,
                id_casa: casa,
                nombre,
                correo: email,
                nit,
                longitud,
                latitud,
                usuario: usuario,
                telefono,
                nombre_fiscal: nombreF,
                direccion_fiscal: direccionF,
            })
            if (data.success) {
                const updatedUser: IUser = {
                    ...userData!,
                    nombre,
                    email,
                    nit,
                    longitud: Number(longitud),
                    latitud: Number(latitud),
                    telefono,
                    nombre_fiscal: nombreF,
                    direccion_fiscal: direccionF,
                }
                dispatch(setUserData(updatedUser))

                return true
            }
            else {
                return false
            }
        }
        catch (error) {
            console.log(error)
            return false
        }

    }


    // Registra el dispositivo solo una vez por usuario
    const registerDeviceOnce = async (user: string, uuid: string, externalId: string) => {
        

        try {
            const { data: regData, status } = await lsApi.put("/api/ControlAcceso/RegistrarDispositivo", {
                uuid: externalId,
                model: navigator.userAgent.includes('Mobile') ? 'Mobile Device' : 'Desktop',
                oS_Name: navigator.platform || 'Unknown',
                key_Device: uuid,
            })

            if (status === 200 && (regData as any)?.success) {
                localStorage.setItem(uuid, '1');
                console.log("Dispositivo registrado exitosamente");
            } else {
                console.error("Error al registrar dispositivo - Status:", status, "Data:", regData)
            }
        }
        catch (error) {
            // No bloquear el flujo si falla el registro
            console.error("Error en el proceso de registro de dispositivo:", error)
        }
    }


    const verificarNit = async (nit: string, nombreF: string) => {

        // Verificar si es CF o C/F o si es un CUI valido
        if (nit === "CF" || nit === "C/F" || esCUI(nit)) {
            return nombreF
        }

        try {
            return await fetch("https://diceros.ls-sys.com/ws/FEL-Condominios/getInfoNIT.php?nit=" + nit)
                .then(response => response.json())
                .then(data => {
                    if (data.name) {
                        return data.name
                    }
                    else {
                        return false
                    }
                })
        }
        catch (error) {
            return false
        }
    }

    const recoverPassword = async (userName: string) => {
        dispatch(setLoading(true))

        try {
            const { data } = await lsApi.put("/api/ControlAcceso/RecordarPassword", { usuario: userName })
            if (data.success) {
                return {
                    success: true,
                    message: data.message || "Se ha enviado una nueva contraseña a su correo electrónico"
                }
            } else {
                return {
                    success: false,
                    message: data.message || "No se pudo procesar la solicitud"
                }
            }
        } catch (error) {
            console.error("Error al recuperar contraseña:", error)
            return {
                success: false,
                message: "Error al procesar la solicitud. Verifique su usuario e intente nuevamente."
            }
        } finally {
            dispatch(setLoading(false))
        }
    }


    return { loginHandler, logoutHandler, updateUserData, validateToken, verificarNit, recoverPassword, registerDeviceOnce }

}

